import { render, staticRenderFns } from "./StatisticDisaster.vue?vue&type=template&id=912787b8"
import script from "./StatisticDisaster.vue?vue&type=script&lang=js"
export * from "./StatisticDisaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports